var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestionMark = function SvgQuestionMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0a8 8 0 1 0 8 8 8.024 8.024 0 0 0-8-8Zm0 14a6 6 0 1 1 6-6 6.018 6.018 0 0 1-6 6Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM8 10a1 1 0 0 1-1-1 3.056 3.056 0 0 1 1.322-2.427c.5-.425.622-.57.622-.906 0-.183 0-.667-.944-.667a2.046 2.046 0 0 0-1.258.56A1 1 0 0 1 5.37 4.106 4.08 4.08 0 0 1 7.95 3a2.68 2.68 0 0 1 2.992 2.666 3.056 3.056 0 0 1-1.318 2.426C9.126 8.519 9 8.662 9 9a1 1 0 0 1-1 1Z",
    fill: "#000"
  })));
};
export default SvgQuestionMark;